function Footer() {
	return (
		<footer className='footer'>
			<span className='footer-text'>
				© 2020, made with ❤️ by{' '}
				<a
					className='footer-link'
					href='https://github.com/westgoten'
					target='_blank'
					rel='noopener noreferrer'>
					westgoten
				</a>
			</span>
			<span className='footer-text'>
				See source code{' '}
				<a
					className='footer-link'
					href='https://github.com/westgoten/movie-catalog'
					target='_blank'
					rel='noopener noreferrer'>
					here
				</a>
			</span>
		</footer>
	)
}

export default Footer
